<template>
  <div class="userTreaty">
    <Header :headerTitle="$t('m.userTreaty.title')"></Header>
    <h5>{{ $t("m.userTreaty.treatyTitle") }}</h5>
    <ul>
      <li>{{ $t("m.userTreaty.agreementNo") }}</li>
      <li class="indent textBottom">{{ $t("m.userTreaty.context1") }}</li>
      <li>
        {{ $t("m.userTreaty.context2") }}
        <br />{{ $t("m.userTreaty.context3") }} <br />{{
          $t("m.userTreaty.context4")
        }}
      </li>
      <li>{{ $t("m.userTreaty.context5") }}</li>
      <li class="indent textBottom">{{ $t("m.userTreaty.context6") }}</li>
      <li>{{ $t("m.userTreaty.text1") }}</li>
      <li>{{ $t("m.userTreaty.context8") }}</li>
      <li>{{ $t("m.userTreaty.context9") }}</li>
      <li>{{ $t("m.userTreaty.context10") }}</li>
      <li>{{ $t("m.userTreaty.context11") }}</li>
      <li>{{ $t("m.userTreaty.text2") }}</li>
      <li>{{ $t("m.userTreaty.context12") }}</li>
      <li>{{ $t("m.userTreaty.context13") }}</li>
      <li>{{ $t("m.userTreaty.text3") }}</li>
      <li>{{ $t("m.userTreaty.context14") }}</li>
      <li>{{ $t("m.userTreaty.context15") }}</li>
      <li>{{ $t("m.userTreaty.context16") }}</li>
      <li>{{ $t("m.userTreaty.context17") }}</li>
      <li>{{ $t("m.userTreaty.context18") }}</li>
      <li>{{ $t("m.userTreaty.context19") }}</li>
      <li>{{ $t("m.userTreaty.context20") }}</li>
      <li>{{ $t("m.userTreaty.context21") }}</li>
      <li>{{ $t("m.userTreaty.text4") }}</li>
      <li class="textBoottom">{{ $t("m.userTreaty.context22") }}</li>
      <li>{{ $t("m.userTreaty.context23") }}</li>
      <li>{{ $t("m.userTreaty.context24") }}</li>
      <b-row>
        <b-col cols="3">{{ $t("m.deductionRuler.row00") }}</b-col>
        <b-col cols="3">{{ $t("m.deductionRuler.row01") }}</b-col>
        <b-col cols="6">{{ $t("m.deductionRuler.row02") }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="3">{{ $t("m.deductionRuler.row10") }}</b-col>
        <b-col cols="3">{{ $t("m.deductionRuler.row11") }}</b-col>
        <b-col cols="6">{{ $t("m.deductionRuler.row12") }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="3">{{ $t("m.deductionRuler.row20") }}</b-col>
        <b-col cols="3">{{ $t("m.deductionRuler.row21") }}</b-col>
        <b-col cols="6">{{ $t("m.deductionRuler.row22") }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="3">{{ $t("m.deductionRuler.row30") }}</b-col>
        <b-col cols="3">{{ $t("m.deductionRuler.row31") }}</b-col>
        <b-col cols="6">{{ $t("m.deductionRuler.row32") }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="3">{{ $t("m.deductionRuler.row40") }}</b-col>
        <b-col cols="3">{{ $t("m.deductionRuler.row41") }}</b-col>
        <b-col cols="6">{{ $t("m.deductionRuler.row42") }}</b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <p>{{ $t("m.deductionRuler.notesTitle") }}</p>
          <ul>
            <li><span>●</span>{{ $t("m.deductionRuler.li1") }}</li>
            <li><span>●</span>{{ $t("m.deductionRuler.li2") }}</li>
          </ul>
        </b-col>
      </b-row>
      <li>{{ $t("m.userTreaty.text5") }}</li>
      <li>{{ $t("m.userTreaty.context25") }}</li>
      <li>{{ $t("m.userTreaty.context26") }}</li>
      <li>{{ $t("m.userTreaty.context27") }}</li>
      <li>{{ $t("m.userTreaty.context28") }}</li>
      <li>{{ $t("m.userTreaty.context29") }}</li>
      <li>{{ $t("m.userTreaty.context30") }}</li>
      <li>{{ $t("m.userTreaty.text6") }}</li>
      <li>{{ $t("m.userTreaty.context31") }}</li>
      <li>{{ $t("m.userTreaty.context32") }}</li>
      <li>{{ $t("m.userTreaty.context33") }}</li>
      <li>{{ $t("m.userTreaty.text7") }}</li>
      <li>{{ $t("m.userTreaty.context34") }}</li>
      <li>{{ $t("m.userTreaty.context35") }}</li>
      <li>{{ $t("m.userTreaty.context36") }}</li>
      <li>{{ $t("m.userTreaty.context37") }}</li>
      <li>{{ $t("m.userTreaty.text8") }}</li>
      <li>{{ $t("m.userTreaty.context38") }}</li>
      <li>{{ $t("m.userTreaty.context39") }}</li>
      <li>{{ $t("m.userTreaty.text9") }}</li>
      <li>{{ $t("m.userTreaty.context40") }}</li>
      <li>{{ $t("m.userTreaty.context41") }}</li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "userTreaty",
  data() {
    return {};
  },
};
</script>
<style scoped>
.userTreaty{
  height: calc(100%);
  overflow: auto;
}
.userTreaty h5 {
  margin-top: 20px;
  font-size: 1.1rem;
}
.userTreaty ul {
  margin: 0 auto;
  list-style: none;
  text-align: left;
  padding: 0 10px;
  font-size: 0.96rem;
  margin-bottom: 20px;
}
.userTreaty .indent {
  text-indent: 2em;
}
.userTreaty .textBottom {
  margin-bottom: 10px;
}
.userTreaty .row {
  /* margin: 5px 0; */
  margin-top: 5px;
  margin-bottom: 5px;
  padding: 0 15px;
  font-size: 0.91rem;
}
.userTreaty .row .col-3 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
  margin-right: 4.5px;
  max-width: 23.5%;
}
.userTreaty .row .col-6 {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f1f1f1;
  padding: 15px 1px;
  margin-bottom: 3px;
  text-align: left;
}
.userTreaty .row .col-12 {
  background-color: #f1f1f1;
  margin-bottom: 3px;
  padding: 0 1px;
}
.userTreaty .row .col-12 p {
  margin: 0;
  font-size: 0.93rem;
}
.userTreaty .row .col-12 ul {
  margin: 0;
  padding: 0;
  font-size: 0.9rem;
  text-align: left;
}
.userTreaty .row .col-12 ul li span {
  float: left;
  margin-top: -1px;
  padding-right: 4px;
}
</style>
